<template>
  <div class="inventinvent">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        库存修改
      </div>
    </div>

    <div class="box">
      <el-col :span="24">
        <el-input
          v-model="invent"
          clearable
          @input="querySearchAsync"
          style="width:30%"
          placeholder="请输入商品id"
        ></el-input>
      </el-col>
      <el-col :span="24">
        <div>库存：{{inventory}}</div>
      </el-col>
      <el-col :span="24">
        <div>商品名称：{{title}}</div>
      </el-col>
      <el-col :span="24">
        <el-input v-model="value" style="width:24%" placeholder="请输入库存数量"></el-input>
        <el-button @click="submit">提交</el-button>
      </el-col>
    </div>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      invent: "",
      inventory: "",
      title: "",
      value: "",
      p_id: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "库存修改";
  },

  methods: {
    querySearchAsync(e) {
      this.p_id = e;
      this.geting(e);
    },
    geting(id) {
      this.axios
        .get(this.serve + "/admin/get_inventory_number", {
          params: {
            username: this.$cookies.get("username"),
            token: this.$cookies.get("token"),
            p_id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.data = res.data.data;
            this.inventory = res.data.data.inventory;
            this.title = res.data.data.title;
          } else {
            this.inventory = "";
            this.title = "";
          }
        });
    },
    submit() {
      this.axios
        .get(this.serve + "/admin/buyer_update_inventory", {
          params: {
            username: this.$cookies.get("username"),
            token: this.$cookies.get("token"),
            p_id: this.p_id,
            inventory: this.value
          }
        })
        .then(res => {
          if(res.data.code == '403'){
            this.$message.error(res.data.msg);
          }else if (res.data.status == "success") {
            this.geting(this.p_id);
            this.$message({
              type: "success",
              message: "操作成功"
            });
          }
        
        });
    }
  }
};
</script>
<style lang="scss">
.inventinvent {
  background: #f5f5f5;
  color: #333;
  min-height: 800px;
  .box {
    width: 1056px;
    margin: 0 auto;
    background: #fff;
    position: relative;
    line-height: 50px;
    color: gray;
  }
  .content {
    width: 20%;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
}
</style>